import { useMutation } from 'react-query';
import { API } from '../../../CommonUtils/axiosWithDefaults';

interface CancelParams {
  batchId: string;
}

const cancelReconciliation = async ({ batchId }: CancelParams): Promise<{ success: boolean }> => {
  return API.post(
    `/Adviser/PdfImport/CancelReconciliation?batchId=${encodeURIComponent(batchId)}`,
  );
};

export const useCancelReconciliationMutation = () => {
  return useMutation(cancelReconciliation);
};
